import { create } from 'zustand';
import { devtools } from 'zustand/middleware';

import api from 'core/api';
import {
  OPERATIONS_PAGINATION_URL,
} from 'utils/api';

const useOperationStore = create()(devtools(
  (set, get) => ({
    shelfCount: 0,
    exclusivesCount: 0,
    getOperationsCount: async (menu) => {
      set(state => ({
        ...state,
        shelfCount: 0,
        exclusivesCount: 0,
      }));
      let shelfCount = 0;
      let exclusivesCount = 0;

      if (menu !== 'novas operações') {
        const [dataShelf, dataExclusives] = await Promise.all([
          api.get(`${OPERATIONS_PAGINATION_URL}/paginacao?PaginaAtual=1&?menu=${menu}&tipoOperacao=prateleira`),
          api.get(`${OPERATIONS_PAGINATION_URL}/paginacao?PaginaAtual=1&?menu=${menu}&tipoOperacao=exclusiva`),
        ]);

        shelfCount = dataShelf?.data?.paginacao.totalItens || 0;
        exclusivesCount = dataExclusives?.data?.paginacao.totalItens || 0;
      } else {
        const [dataShelf, dataExclusives] = await Promise.all([
          api.get('/tradeidea?Pagina=1&TamanhoPagina=21&Tipo=prateleira'),
          api.get('/tradeidea?Pagina=1&TamanhoPagina=21&Tipo=exclusiva'),
        ]);

        shelfCount = dataShelf?.data?.informacoesPagina?.quantidadeRegistros || 0;
        exclusivesCount = dataExclusives?.data?.informacoesPagina?.quantidadeRegistros || 0;
      }

      set(state => ({
        ...state,
        shelfCount,
        exclusivesCount,
      }));
    },
  }),
));

export default useOperationStore;
